import axios from "axios"
import { Toast } from 'vant-green';

const service = axios.create();

service.defaults = {
  timeout: 15000,
}

service.interceptors.request.use(config => {
  //config.headers.Authorization = getToken();
  return config;
})

service.interceptors.response.use(response => {
	return response.data;
//	const code = response.data.code || 200;
//	const msg = response.data.msg || 'error';
	
//  if (code != 200 || code!=0) {
//    Toast.fail(msg);
//  } else {
//	  return response.data;
//  }
}, err => {
  Toast.fail("system error");
  // if ([500, 501, 502, 503, 504].includes(err.response.status)) {
  //   Toast.fail('系统错误，请稍后再试');
  // } else {
  //   Toast.fail(err.response.status + ' ' + err.response.statusText);
  // }
})

export default service;